import React from "react";

interface BlockButtonProps {
  text?: string;
  onClick?: () => void;
  dataTestId?: string;
  disabled?: boolean;
}

const BlockButton = ({ text, onClick, dataTestId, disabled }: BlockButtonProps) => {
  return (
    <button disabled={disabled} className="block-button" data-testid={dataTestId} onClick={onClick}>
      {text}
    </button>
  );
};

export default BlockButton;
